import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AUTH_FEATURE_KEY } from './auth-store.reducer';
import { AuthState } from './auth-store.state';

// Lookup the 'Auth' feature state managed by NgRx
const getAuthState = createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);

export const getIsLoggedIn = createSelector(
    getAuthState,
    state => state.loggedIn
);

export const getLogInErrorMessage = createSelector(
    getAuthState,
    state => state.error
);

export const getUser = createSelector(
    getAuthState,
    state => state.user
);

export const isLoading = createSelector(
    getAuthState,
    state => state.loading
);

// export const getUserTenants = createSelector(
//     getUser,
//     user => (user && user.tenants ? user.tenants : undefined)
// );

// export const userHasTenant = createSelector(
//     getUserTenants,
//     tenants => tenants && Object.keys(tenants).length > 0
// );



// export const sessionExpired = createSelector(
//     getAuthState,
//     state => state.sessionExpired
// );
